import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import LabelledInput from 'Components/Form/LabelledInput';
import Error from 'Components/Form/Error';

import RegisterSelectTeams from './RegisterSelectTeams';

import { register } from 'cognito/auth';

const EMAIL_PATTERN = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const MIN_PASSWORD_LENGTH = 10;

function Register ()
{
    const navigate = useNavigate ();

    const [ email, setEmail ] = useState ( localStorage.getItem ( "email" ) ? localStorage.getItem ( "email" ) : "" );
    const [ password, setPassword ] = useState ( "" );
    const [ confirmPassword, setConfirmPassword ] = useState ( "" );
    const [ selectedTeams, setSelectedTeams ] = useState ( null );
    const [ isLoading, setIsLoading ] = useState ( false );
    const [ error, setError ] = useState ( { isError: false, message: null } );

    const [ isPasswordTouched, setIsPasswordTouched ] = useState ( false );
    const [ isConfirmPasswordTouched, setIsConfirmPasswordTouched ] = useState ( false );

    const doSignIn = async () =>
    {
        setError ( { isError: false, message: null } );
        setIsLoading ( true );

        try
        {
            const result = await register ( email, password, selectedTeams.location, selectedTeams.region, selectedTeams.team );
            console.log ( result );
            localStorage.setItem ( "email", email );
            setError ( { isError: false, message: null } );
            setIsLoading ( false );

            navigate ( '/participant/register/confirm' );
        }
        catch ( error )
        {
            if ( error.name === "UsernameExistsException" )
            {
                setError ( { isError: true, message: "User is already registered" } );
            }
            else if ( error.name === "UserLambdaValidationException" )
            {
                if ( error.message?.includes ( "Registration requires a PureGym email address" ) )
                {
                    setError ( { isError: true, message: "A valid PureGym email address is required to register" } );
                }
                else
                {
                    setError ( { isError: true, message: "Registration failed validation" } );
                }
            }
            else
            {
                setError ( { isError: true, message: error.name } );
            }

            setIsLoading ( false );
        }
    }

    const isInputValid = () =>
    {
        return EMAIL_PATTERN.test ( email ) && 
                password.length >= MIN_PASSWORD_LENGTH && password === confirmPassword &&
                selectedTeams !== null &&
                selectedTeams.location?.length > 0 &&
                selectedTeams.region?.length > 0 &&
                selectedTeams.team?.length > 0;
    }

    const doesNotMatch = !isConfirmPasswordTouched || password === confirmPassword ? null : <span className="bg-pgred text-pgwhite font-bold inline-block m-2 p-2 rounded-lg">Passwords do not match</span>
    const tooShort = !isPasswordTouched || password.length >= MIN_PASSWORD_LENGTH ? null : <span className="bg-pgred text-pgwhite font-bold inline-block m-2 p-2 rounded-lg">Password is too short</span>    

    return  <div className="w-full sm:w-4/6 md:w-3/6 m-auto">
                <h1>Register</h1>
                <hr />
                <p className="py-4">This site is for PureGym team members only. Any data collected during the 100K campaign is for internal use only and will be deleted at the end of the campaign.</p>
                <hr className="py-2" />
                <form>
                    { error.isError && <Error message={error.message} /> }
                    <LabelledInput id="email" label="Email" value={email} onChange={ ( newValue ) => setEmail ( newValue ) } type="email" />
                    <LabelledInput id="password" label="Password" error={tooShort} onChange={ ( newValue ) => setPassword ( newValue ) } type="password" onBlur={ () => setIsPasswordTouched ( true ) }/>
                    <LabelledInput id="confirmPassword" label="Confirm Password" error={doesNotMatch} value={confirmPassword} onChange={ ( newValue ) => setConfirmPassword ( newValue ) } type="password" onBlur={ () => setIsConfirmPasswordTouched ( true ) } />
                    <RegisterSelectTeams selectedTeams={selectedTeams} setSelectedTeams={ ( teams ) => setSelectedTeams ( teams ) } />
                    <div className="flex-row gap-8">
                        <button onClick={ () => doSignIn () } disabled={ !isInputValid () || isLoading } type="submit">Register</button>
                        <Link to="/participant/login">Or login here</Link>
                    </div>
                </form>
            </div>
}

export default Register;